// CANONICAL COPY (GH #7115). src/constants/obligations/obl-ski-third-party-software-modification.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-ski-third-party-software-modification',
  title: 'Apply a documented process for modifying third-party software including risk assessment',
  description:
    "Any modification to baseline code in third-party software packages used by the customer must follow a documented customisation process. The process must account for the risk that: the third party may no longer support the software; built-in security controls may be broken; and the software may become difficult to update in future. Modifications may only be made with the customer's formal risk acceptance.",
  category: 'technical',
  scfIds: ['SCF-DEV-008', 'SCF-VDR-003'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    {
      type: 'document-published',
      description: 'Third-party software modification process is documented',
    },
    { type: 'document-approved', description: 'Process has been approved' },
    { type: 'document-within-sla', description: 'Process review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
